<template>
    <div class="worklist">
        <div style="position: fixed; z-index: 99; top: 0px; left: 0px; width: 100%;">
            <el-row style="background-color: #00BAFF; color: #fff; font-weight: bold; padding: 10px 0px;" type="flex" align="middle">
                <el-col :span="8" style="text-align: center; font-size: 20px;">企业名称</el-col>
                <el-col :span="16" style="text-align: center; font-size: 20px;">
                    反馈问题
                </el-col>
            </el-row>
        </div>

        <el-row v-for="(item, index) in list_grid_feedback" :style="getStyByIndex(index)" type="flex" align="middle">
            <el-col :span="8" class="colsty">
                <!-- {{ item.gridCode }} -->
                  <!-- # {{ index + 1 }} -->
                  {{ item.comName }}
            </el-col>
            <el-col :span="16" class="colsty">
                {{ item.feedbackContent }}
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list_grid_feedback: {
            },
        }
    },
    mounted() {
        // 设置定时器每隔一定时间滚动一次
        setInterval(() => {
            // 向上滚动50px
            window.scrollBy(0, 20)

            let scrollY = window.scrollY
            let windowHeight = window.innerHeight
            let documentHeight = document.body.scrollHeight
            console.log('scrollY',scrollY, 'windowHeight',windowHeight, 'documentHeight',documentHeight)
            if (scrollY + windowHeight >= documentHeight) {
                console.log('已经滚动到底部，重新处理……')
                window.scrollBy(0, -documentHeight);
            }
        }, 2000); // 100毫秒滚动一次
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
    },
    created() {
        this.getGridworkplan()
    },
    methods: {

        // 获取网格工作计划
        getGridworkplan() {
            // let url = 'http://localhost:58080/pubapi/bigscreengrid/getFeedback'
            let url = 'http://cfzx.apps.ac.cn/pubapi/bigscreengrid/getFeedback'
            this.$axios(url).then((res) => {
                console.log(res.data.data)
                this.list_grid_feedback = res.data.data
            })
        },

        // 根据索引获取行样式
        getStyByIndex(index) {
            if (index == 0) {
                return 'background-color: #003B51; color: #fff; margin-top: 47px;'
            } else if (index > 0) {
                if (index % 2 == 0) {
                    return 'background-color: #003B51; color: #fff;'
                } else {
                    return 'background-color: #0A2732; color: #fff;'
                }
            }
        },

    }
}
</script>
<style scoped>
.worklist {
    margin: 0;
    width: 100%;
    height: auto;
    background-color: #02162A;
}
.colsty {
    text-align: left; 
    font-size: 18px; 
    padding: 23px 15px;
    border-right: 1px solid #666;
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; */
}
</style>